import { defineComponent } from 'vue';
import ActAddUsersCode from '@/presentation/components/act-access-modal/act-add-users/act-add-users.code';

export default defineComponent({
	setup: () => {
		const code = new ActAddUsersCode();

		return {
			addUsersInputField: code.addUsersInputField,
			actUsersToAdd: code.actUsersToAdd,
			amountOfUsersBasedSentence: code.amountOfUsersBasedSentence,
			invalidEntriesMessage: code.invalidEntriesMessage,
			isEntryInvalid: code.isEntryInvalid.bind(code),
			handleTextInput: code.handleTextInput.bind(code),
			handlePastInput: code.handlePastInput.bind(code),
			analyseTextInputForUsersToAdd: code.analyseTextInputForUsersToAdd.bind(code),
			removeUserToAdd: code.removeUserToAdd.bind(code)
		};
	}
});
